import { render, staticRenderFns } from "./AdvertisingSpace.vue?vue&type=template&id=85e5fbcc&scoped=true&"
import script from "./AdvertisingSpace.vue?vue&type=script&lang=js&"
export * from "./AdvertisingSpace.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingSpace.vue?vue&type=style&index=0&id=85e5fbcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e5fbcc",
  null
  
)

export default component.exports